import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { FormBuilder, Validators, AbstractControl, FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { DatePipe } from '@angular/common';
import { CommonService } from 'app/_services/common.service'


@Component({
  selector: 'app-status-signup',
  templateUrl: './status-signup.component.html',
  styleUrls: ['./status-signup.component.css']
})
export class StatusSignupComponent implements OnInit {

  veteranForm = this
  .formBuilder
  .group({
    veteranStatus: [
      '', Validators.required
    ],
  });

  
  incomeTaxForm = this
  .formBuilder
  .group({
    selectedIncomeTax: [
      '', Validators.required
    ],
  });

  seniorForm = this
  .formBuilder
  .group({
    selectedSeniorStatus: [
      '', Validators.required
    ],
  });

  disabilityForm = this
  .formBuilder
  .group({
    selectedDisabilityStatus: [
      '', Validators.required
    ],
  });

  healthInsuranceForm = this
  .formBuilder
  .group({
    selectedHealthStatus: [
      '', Validators.required
    ],
  });
  
  discriminationForm = this
  .formBuilder
  .group({
    selectedDiscriminationStatus: [
      '', Validators.required
    ],
  });

  public moduleTitle;
  public isVeteran : boolean;
  public isIncomeTax : boolean;
  public isSenior : boolean;
  public isDisability : boolean;
  public isHealthInsurance : boolean;
  public isDiscrimination : boolean;
  public veteran_status;
  public yVeteran;
  public nVeteran;
  public income_status;
  public yIncome;
  public nIncome;
  public senior_status;
  public ySenior;
  public nSenior
  public disability_status;
  public yDisability;
  public nDisability;
  public health_insuarance_status;
  public yHealth;
  public nHealth;
  public discrimination_status;
  public yDiscrimination;
  public nDiscrimination;

  constructor(
    public dialogRef: MatDialogRef<StatusSignupComponent>,
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private commonService : CommonService,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any


  ) {
    this.moduleTitle = data.action;
   }
  
   
  ngOnInit(): void {
    this.veteran_status =  JSON.parse(localStorage.getItem('veteran_status'));
    this.income_status =  JSON.parse(localStorage.getItem('income_status'));
    this.senior_status =  JSON.parse(localStorage.getItem('senior_status'));
    this.disability_status =  JSON.parse(localStorage.getItem('disability_status'));
    this.health_insuarance_status =  JSON.parse(localStorage.getItem('health_insuarance_status'));
    this.discrimination_status =  JSON.parse(localStorage.getItem('discrimination_status'));
    this.checkStatus();

    localStorage.setItem('discrimination_status',null)

  }

  checkStatus(){
    //veteran
    if(this.moduleTitle == "veteran"){
      this.isVeteran = true
  
      if(this.veteran_status === 1){
      this.yVeteran = "true";
    } 
    else if( this.veteran_status === 0){
      this.nVeteran = "true";

    }
    else {
      this.nVeteran = "false";
      this.yVeteran = "false";
    }
    }
    
    //income tax
    if(this.moduleTitle == "incomeTax"){
      this.isIncomeTax = true
      
      if(this.income_status === 1){
        this.yIncome = "true";
      }
      else if(this.income_status === 0){
        this.nIncome = "true";
      }
      else {
        this.yIncome = "false";
        this.nIncome = "false";

      }
    }

    //senior
    if(this.moduleTitle == "senior"){
      this.isSenior = true

      if(this.senior_status === 1){
        this.ySenior = "true";
      }
      else if(this.senior_status === 0) {
        this.nSenior = "true";
      }
      else {
        this.ySenior = "false";
        this.nSenior = "false";

      }
    }

    //disability
    if(this.moduleTitle == "disability"){
      this.isDisability = true

      
      if(this.disability_status === 1){
        this.yDisability = "true";
      }
      else if (this.disability_status === 0){
        this.nDisability = "true";
      } 
      else {
        this.yDisability = "false";
        this.nDisability = "false";

      }

    }

    //health
    if(this.moduleTitle == "healthInsurance"){
      this.isHealthInsurance = true

      if(this.health_insuarance_status === 1){
        this.yHealth = "true";
      }

      else if (this.health_insuarance_status === 0){
        this.nHealth = "true";
      }
      else {
        this.yHealth = "false";
        this.nHealth = "false";

      }
    }

    //discrimination
    if(this.moduleTitle == "discrimination"){
      this.isDiscrimination = true

      
      
    }
  }

  submitVeteranStatus(){
    if(this.veteranForm.value.veteranStatus != undefined){
      localStorage.setItem('veteran_status',this.veteranForm.value.veteranStatus)
    }
    this.dialogRef.close({
      event: 'veteran',
      // isUpdated: true
    })
  }

  submitIncomTax(){
    if(this.incomeTaxForm.value.selectedIncomeTax != undefined){
      localStorage.setItem('income_status',this.incomeTaxForm.value.selectedIncomeTax)

    }
   console.log(" this.incomeTaxForm.value", this.incomeTaxForm.value);
    this.dialogRef.close({
      event: 'incomeTax',
      // isUpdated: true
    })
  }

  submitSeniorStatus(){
    if(this.seniorForm.value.selectedSeniorStatus != undefined){
      localStorage.setItem('senior_status', this.seniorForm.value.selectedSeniorStatus)
    }
    console.log(" this.senior.value", this.seniorForm.value);
    this.dialogRef.close({
      event: 'senior',
      // isUpdated: true
    })
  }

  submitDisabilityStatus(){
    if(this.disabilityForm.value.selectedDisabilityStatus != undefined){
      localStorage.setItem('disability_status',this.disabilityForm.value.selectedDisabilityStatus)

    }

    console.log("disability", this.disabilityForm.value);
     this.dialogRef.close({
       event: 'disability',
       // isUpdated: true
     })
   }
 
   submitHealthInsurance(){
     if(this.healthInsuranceForm.value.selectedHealthStatus != undefined){
      localStorage.setItem('health_insuarance_status',this.healthInsuranceForm.value.selectedHealthStatus)

     }

     console.log("submitHealthInsurance", this.healthInsuranceForm.value);
     this.dialogRef.close({
       event: 'healthInsurance',
       // isUpdated: true
     })
   }

   submitDiscrimination(){
     if(this.discriminationForm.value.selectedDiscriminationStatus != undefined){
      localStorage.setItem('discrimination_status',this.discriminationForm.value.selectedDiscriminationStatus)

     }

    console.log("submitDiscrimination", this.discriminationForm.value);
    this.dialogRef.close({
      event: 'discrimination',
      // isUpdated: true
    })
  }

  
  navigateFromLogin() {
    let isLoggedIn = localStorage.getItem('isLoggedIn');

    if (isLoggedIn === "true") {
      this.router.navigate(['/user-history'])
    } else {
      alert("No History Found, Please login");
      this.router.navigate(['/login'])

    }
  }
  
  navigateMenu(){
    this.router.navigate(['/search1-screen']);
    console.log("navigateMenu")
  }

  
}
